import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Network from './Requests';
import { setProductStore, setSourceStore } from '../store/reducers/saveGuids';
import { useTranslation } from "react-i18next";

function getProjectName() {
  const now = new Date();

  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const timeWithoutSeconds = `${hours}:${minutes}`;

  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = String(now.getFullYear()).slice(-2); // Последние две цифры года
  const date = `${day}.${month}.${year}`;

  return `${timeWithoutSeconds} Проект ${date}`;
}
const AddingProjectTemplate = (props) => {
  const { t } = useTranslation();

  const [name, setName] = React.useState(getVariantName);
  const [number, setNumber] = React.useState('');
  const [address, setAddress] = React.useState('');
  const [fullName, setFullName] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [clientEmail, setClientEmail] = React.useState('');
  const [descr, setDescr] = React.useState('');
  const [amoLink, setAmoLink] = React.useState('');
  const [source, setSource] = React.useState([]);
  const [sourceSelect, setSourceSelect] = React.useState(0);
  const [productType, setProductType] = React.useState([]);
  const [productTypeSelect, setProductTypeSelect] = React.useState(0);
  const [sum, setSum] = React.useState('');
  const [term, setTerm] = React.useState('');
  const [requestDate, setRequestDate] = React.useState(
    new Date().toLocaleDateString() + ' ' + new Date().toTimeString().substring(0, 8),
  );
  const [completeDate, setCompleteDate] = React.useState('');
  const [orderingDate, setOrderingDate] = React.useState('');
  const [archiveDate, setArchiveDate] = React.useState('');
  const [feedback, setFeedback] = React.useState('');
  const [workCosts, setWorkCosts] = React.useState(0);
  const [materialCosts, setMaterialCosts] = React.useState(0);
  const [costsRemark, setCostsRemark] = React.useState('');
  const [folders, setFolders] = React.useState([]);
  const [folderSelect, setFolderSelect] = React.useState('');
  const dispatch = useDispatch();

  const [edit, setEdit] = React.useState(false);
  const [confirmForm, setConfirmForm] = React.useState(false);
  const saveVariant = useSelector((state) => state?.project?.saveVariant);
  let productStore = useSelector((state) => state?.guids?.product);
  let sourceStore = useSelector((state) => state?.guids?.source);
  let foldersStore = useSelector((state) => state?.guids.folders);

  useEffect(() => {
    if (props.show) {
      const element = document.querySelector('.template-projects');
      if (element && element.classList.contains('active')) {
        element.classList.remove('active');
      }
    }
  }, [props.show]);

  const getData = async () => {
    let products = await new Network().GetProductTypes();
    let sources = await new Network().GetSourceTypes();
    setProductType(products);
    setSource(sources);
    setFolders(foldersStore);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (props.current != undefined) {
      setName(props.current.projectNameOriginal);
      setNumber(props.current.orderNumber);
      setAddress(props.current.address);
      setFullName(props.current.customerFullName);
      setPhone(props.current.phoneNumber);
      setClientEmail(props.current.clientEmail);
      setDescr(props.current.description);
      setAmoLink(props.current.amoCRMLink);
      props.current.idSourceType == null
        ? setSourceSelect(0)
        : setSourceSelect(props.current.idSourceType);
      props.current.idProductType == null
        ? setProductTypeSelect(0)
        : setProductTypeSelect(props.current.idProductType);
      setSum(props.current.sum);
      setRequestDate(
        props.current.requestDate?.substring(0, 10) +
          ' ' +
          props.current.requestDate?.substring(11, 19),
      );
      setOrderingDate(props.current.orderDate?.substring(0, 10));
      setTerm(props.current.expirationDate?.substring(0, 10));
      setCompleteDate(props.current.orderCompletionDate?.substring(0, 10));
      setArchiveDate(props.current.archivedDate?.substring(0, 10));
      setFeedback(props.current.feedback);
      setWorkCosts(props.current.workCosts);
      setMaterialCosts(props.current.materialCosts);
      setCostsRemark(props.current.costsNote);
      setFolderSelect(props.current.currentCRMGroup?.guid);
    }
  }, [props.current]);

  const handlerChangeName = (e) => {
    setName(e);
  };

  const handlerChangeNumber = (e) => {
    setNumber(e);
  };

  const handlerChangeAddress = (e) => {
    setAddress(e);
  };

  const handlerChangeFullName = (e) => {
    setFullName(e);
  };

  const handlerChangePhone = (e) => {
    setPhone(e);
  };

  const handlerChangeDescr = (e) => {
    setDescr(e);
  };

  const handlerChangeAmoLink = (e) => {
    setAmoLink(e);
  };

  // const handlerChangeSource = (e) => {
  //   setSource(e);
  // };

  // const handlerChangeProductType = (e) => {
  //   setProductType(e);
  // };

  const handlerChangeSum = (e) => {
    setSum(e);
  };

  const handlerChangeTerm = (e) => {
    setTerm(e);
  };

  const handlerChangeRequestDate = (e) => {
    setRequestDate(e);
  };

  const handlerChangeFeedback = (e) => {
    setFeedback(e);
  };

  const handlerChangeCompleteDate = (e) => {
    setCompleteDate(e);
  };

  const handlerChangeArchiveDate = (e) => {
    setArchiveDate(e);
  };

  const handlerChangeOrderingDate = (e) => {
    setOrderingDate(e);
  };

  const handlerChangeEmail = (e) => {
    setClientEmail(e);
  };

  const handlerChangeWorkCost = (e) => {
    setWorkCosts(e);
  };

  const handlerChangeMaterialCost = (e) => {
    setMaterialCosts(e);
  };

  const handlerChangeCostsRemark = (e) => {
    setCostsRemark(e);
  };

  const cleanUp = () => {
    setName(getVariantName);
    setNumber('');
    setAddress('');
    setFullName('');
    setPhone('');
    setClientEmail('');
    setAmoLink('');
    setProductTypeSelect(0);
    setSourceSelect(0);
    // setSource([]);
    // setProductType([]);
    setSum('');
    setRequestDate(
      new Date().toLocaleDateString() + ' ' + new Date().toTimeString().substring(0, 8),
    );
    setOrderingDate('');
    setTerm('');
    setCompleteDate('');
    setArchiveDate('');
    setFeedback('');
    setDescr('');
    setWorkCosts(0);
    setMaterialCosts(0);
    setCostsRemark('');
  };

  const saveProject = () => {
    props.save(
      name,
      number,
      address,
      fullName,
      phone,
      clientEmail,
      amoLink,
      sourceSelect,
      productTypeSelect,
      sum,
      requestDate,
      orderingDate,
      term,
      completeDate,
      archiveDate,
      feedback,
      descr,
      workCosts,
      materialCosts,
      costsRemark,
      folderSelect,
    );
    setEdit(true);
    props.current != undefined ? handleBack() : handleCloseProject();
  };

  const handleCloseProject = () => {
    cleanUp();
    props.close();
  };
  const handleClose = () => {
    setConfirmForm(true);
  };

  const сhangeSource = (event) => {
    setSourceSelect(event.target.value);
  };

  const сhangeProduct = (event) => {
    setProductTypeSelect(event.target.value);
  };

  const changeStatus = (event) => {
    setFolderSelect(event.target.value);
  };

  const setInitialState = () => {
    if (props.current != undefined && edit == false) {
      setName(props.current.projectNameOriginal);
      setNumber(props.current.orderNumber);
      setAddress(props.current.address);
      setFullName(props.current.customerFullName);
      setPhone(props.current.phoneNumber);
      setClientEmail(props.current.clientEmail);
      setDescr(props.current.description);
      setAmoLink(props.current.amoCRMLink);
      setSourceSelect(props.current.idSourceType);
      setProductTypeSelect(props.current.idProductType);
      setSum(props.current.sum);
      setRequestDate(
        props.current.requestDate?.substring(0, 10) +
          ' ' +
          props.current.requestDate?.substring(11, 19),
      );
      setOrderingDate(props.current.orderDate?.substring(0, 10));
      setTerm(props.current.expirationDate?.substring(0, 10));
      setCompleteDate(props.current.orderCompletionDate?.substring(0, 10));
      setArchiveDate(props.current.archivedDate?.substring(0, 10));
      setFeedback(props.current.feedback);
      setWorkCosts(props.current.workCosts);
      setMaterialCosts(props.current.materialCosts);
      setCostsRemark(props.current.costsNote);
      setFolderSelect(props.current.currentCRMGroup.guid);
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  function getVariantName() {
    const now = new Date();

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const timeWithoutSeconds = `${hours}:${minutes}`;

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2); // Last two digits of the year
    const date = `${day}.${month}.${year}`;

    return `${timeWithoutSeconds} Проект ${date}`;
  }

  const handleBack = () => {
    props.back();
  };

  const projectNotSave = () => {
    setConfirmForm(false);
    props.close();
    cleanUp();

    // Add `active` class back to element with class name `template-projects`
    const element = document.querySelector('.template-projects');
    if (element && !element.classList.contains('active')) {
      element.classList.add('active');
    }
  };

  const projectSave = () => {
    setConfirmForm(false);
    saveProject();
    cleanUp();
    props.close();
  };

  return (
    <>
      <Dialog
        open={confirmForm}
        onClose={() => {
          setConfirmForm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("adding.confirmSave")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={projectSave} color="primary">
            {t("yes")}
          </button>
          <button onClick={projectNotSave} color="primary">
            {t("no")}
          </button>
        </DialogActions>
      </Dialog>
      {props.slice == true ? (
        <>
          <div className="top-panel">
            <p onClick={handleBack} className="top-panel--close">
              {t("back")}
            </p>
          </div>
          <div className="slice-temp">
            <div class="infoList--title">
              {saveVariant ? t("adding.variantName") : t("adding.projectInfo")}
            </div>
            <div className="templates">
              {saveVariant ? (
                <input
                  type="text"
                  placeholder={t("adding.variantTitlePlaceholder")}
                  value={name}
                  onChange={(e) => handlerChangeName(e.target.value)}
                />
              ) : (
                <>
                  <label class="input-title"> {t("adding.orderNumber")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.orderNumber")}
                    value={number}
                    onChange={(e) => handlerChangeNumber(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.projectTitle")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.projectTitle")}
                    value={name}
                    onChange={(e) => handlerChangeName(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.address")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.address")}
                    value={address}
                    onChange={(e) => handlerChangeAddress(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.fullName")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.fullName")}
                    value={fullName}
                    onChange={(e) => handlerChangeFullName(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.phone")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.phone")}
                    value={phone}
                    onChange={(e) => handlerChangePhone(e.target.value)}
                  />
                  <label class="input-title"> Email </label>
                  <input
                    type="text"
                    placeholder="Email"
                    value={clientEmail}
                    onChange={(e) => handlerChangeEmail(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.amo")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.amo")}
                    value={amoLink}
                    onChange={(e) => handlerChangeAmoLink(e.target.value)}
                  />
                  <FormControl fullWidth>
                    <label class="input-title"> {t("adding.source")} </label>
                    <Select
                      value={sourceSelect}
                      onChange={сhangeSource}
                      className="input-title"
                      MenuProps={MenuProps}>
                      <MenuItem value={0}> {t("adding.source")} </MenuItem>
                      {source?.map((c) => {
                        return <MenuItem value={c.id}>{c.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <label class="input-title"> {t("adding.productType")} </label>
                    <Select
                      value={productTypeSelect}
                      onChange={сhangeProduct}
                      className="input-title"
                      MenuProps={MenuProps}>
                      <MenuItem value={0}>{t("adding.productType")}</MenuItem>
                      {productType?.map((c) => {
                        return <MenuItem value={c.id}>{c.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <label class="input-title"> {t("adding.sum")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.sum")}
                    value={sum}
                    onChange={(e) => handlerChangeSum(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.chatCreatedAt")} </label>
                  <TextField
                    id="date"
                    type="text"
                    disabled={true}
                    fullWidth
                    className="dataTimer dataTimer--pad1"
                    value={requestDate}
                  />
                  <label class="input-title"> {t("adding.orderDate")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad"
                    value={orderingDate}
                    onChange={(e) => handlerChangeOrderingDate(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.orderDeadline")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad"
                    value={term}
                    onChange={(e) => handlerChangeTerm(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.orderCompleteDate")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad"
                    value={completeDate}
                    onChange={(e) => handlerChangeCompleteDate(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.archiveDate")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad2"
                    value={archiveDate}
                    onChange={(e) => handlerChangeArchiveDate(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.projectDescription")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.projectDescription")}
                    value={descr}
                    onChange={(e) => handlerChangeDescr(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.feedback")} </label>
                  <textarea
                    style={{ marginBottom: 10 }}
                    placeholder={t("adding.feedback")}
                    value={feedback}
                    onChange={(e) => handlerChangeFeedback(e.target.value)}></textarea>
                  <label class="input-title"> {t("adding.costsWork")} </label>
                  <TextField
                    id="standard-number"
                    label=""
                    type="number"
                    fullWidth
                    className="numberInput"
                    value={workCosts}
                    onChange={(e) => handlerChangeWorkCost(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.costsMaterial")} </label>
                  <TextField
                    id="standard-number"
                    label=""
                    type="number"
                    fullWidth
                    className="numberInput numberInput--pad"
                    value={materialCosts}
                    onChange={(e) => handlerChangeMaterialCost(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.costsNote")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.costsNotePlaceholder")}
                    value={costsRemark}
                    onChange={(e) => handlerChangeCostsRemark(e.target.value)}
                  />
                  <FormControl fullWidth sx={{ marginBottom: '10px' }}>
                    <label class="input-title"> {t("adding.status")} </label>
                    <Select
                      value={folderSelect}
                      onChange={changeStatus}
                      className="input-title"
                      MenuProps={MenuProps}>
                      <MenuItem value={props.current?.currentCRMGroup?.guid}>
                        {props.current?.currentCRMGroup?.name}
                      </MenuItem>
                      {folders?.map((c) => {
                        return <MenuItem value={c.guid}>{c.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </>
              )}
              <button onClick={saveProject}>{t("save")}</button>
            </div>
          </div>
        </>
      ) : (
        <Dialog
          open={props.show}
          keepMounted
          onClose={handleClose}
          TransitionProps={{ onEnter: setInitialState }}>
          <DialogContent>
            <div class="infoList--title">
              {saveVariant ? t("adding.variantName") : t("adding.projectInfo")}
            </div>
            <div className="templates">
              {saveVariant ? (
                <input
                  type="text"
                  placeholder={t("adding.variantTitlePlaceholder")}
                  value={name}
                  onChange={(e) => handlerChangeName(e.target.value)}
                />
              ) : (
                <>
                  <label class="input-title"> {t("adding.orderNumber")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.orderNumber")}
                    value={number}
                    onChange={(e) => handlerChangeNumber(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.projectTitle")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.projectTitle")}
                    value={name}
                    onChange={(e) => handlerChangeName(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.address")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.address")}
                    value={address}
                    onChange={(e) => handlerChangeAddress(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.fullName")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.fullName")}
                    value={fullName}
                    onChange={(e) => handlerChangeFullName(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.phone")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.phone")}
                    value={phone}
                    onChange={(e) => handlerChangePhone(e.target.value)}
                  />
                  <label class="input-title"> Email </label>
                  <input
                    type="text"
                    placeholder="Email"
                    value={clientEmail}
                    onChange={(e) => handlerChangeEmail(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.amo")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.amo")}
                    value={amoLink}
                    onChange={(e) => handlerChangeAmoLink(e.target.value)}
                  />
                  <FormControl fullWidth>
                    <label class="input-title"> {t("adding.source")} </label>
                    <Select
                      value={sourceSelect}
                      onChange={сhangeSource}
                      label={t("adding.source")}
                      className="input-title"
                      MenuProps={MenuProps}>
                      <MenuItem value={0}> {t("adding.source")} </MenuItem>
                      {source?.map((c) => {
                        return <MenuItem value={c.id}>{c.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <label class="input-title"> {t("adding.productType")} </label>
                    <Select
                      value={productTypeSelect}
                      onChange={сhangeProduct}
                      label={t("adding.productType")}
                      className="input-title"
                      MenuProps={MenuProps}>
                      <MenuItem value={0}>{t("adding.productType")}</MenuItem>
                      {productType?.map((c) => {
                        return <MenuItem value={c.id}>{c.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <label class="input-title"> {t("adding.sum")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.sum")}
                    value={sum}
                    onChange={(e) => handlerChangeSum(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.chatCreatedAt")} </label>
                  <TextField
                    id="date"
                    type="text"
                    disabled={true}
                    fullWidth
                    className="dataTimer dataTimer--pad1"
                    value={requestDate}
                  />
                  <label class="input-title"> {t("adding.orderDate")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad"
                    value={orderingDate}
                    onChange={(e) => handlerChangeOrderingDate(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.orderDeadline")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad"
                    value={term}
                    onChange={(e) => handlerChangeTerm(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.orderCompleteDate")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad"
                    value={completeDate}
                    onChange={(e) => handlerChangeCompleteDate(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.archiveDate")} </label>
                  <TextField
                    id="date"
                    type="date"
                    fullWidth
                    className="dataTimer dataTimer--pad2"
                    value={archiveDate}
                    onChange={(e) => handlerChangeArchiveDate(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.projectDescription")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.projectDescription")}
                    value={descr}
                    onChange={(e) => handlerChangeDescr(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.feedback")} </label>
                  <textarea
                    placeholder={t("adding.feedback")}
                    style={{ marginBottom: 10 }}
                    value={feedback}
                    onChange={(e) => handlerChangeFeedback(e.target.value)}></textarea>
                  <label class="input-title"> {t("adding.costsWork")} </label>
                  <TextField
                    id="standard-number"
                    type="number"
                    fullWidth
                    className="numberInput"
                    onChange={(e) => handlerChangeWorkCost(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.costsMaterial")} </label>
                  <TextField
                    id="standard-number"
                    type="number"
                    fullWidth
                    className="numberInput numberInput--pad"
                    onChange={(e) => handlerChangeMaterialCost(e.target.value)}
                  />
                  <label class="input-title"> {t("adding.costsNote")} </label>
                  <input
                    type="text"
                    placeholder={t("adding.costsNotePlaceholder")}
                    value={costsRemark}
                    onChange={(e) => handlerChangeCostsRemark(e.target.value)}
                  />
                </>
              )}
            </div>
          </DialogContent>
          <DialogActions
            style={{
              display: 'flex',
              padding: '20px',
              justifyContent: 'space-between',
              backgroundColor: 'white',
              boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
            }}>
            <button
              onClick={saveProject}
              style={{
                flexGrow: 2, // makes button take twice as much space
                marginRight: '10px',
              }}>
              {t("save")}
            </button>
            <button
              onClick={handleClose}
              style={{
                flexGrow: 2, // makes button take twice as much space
                marginRight: '10px',
              }}>
              {t("cancel")}
            </button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
export default AddingProjectTemplate;